import { Md5 } from 'ts-md5';
export class UserKey {
    constructor(Login, ConnectionName, clientType = null) {
        var _a;
        this.Login = '';
        this.ConnectionName = '';
        this.clientType = '';
        this.Login = Login;
        this.ConnectionName = ConnectionName;
        this.clientType = (_a = clientType === null || clientType === void 0 ? void 0 : clientType.toString()) !== null && _a !== void 0 ? _a : '';
    }
    getKey() {
        return Md5.hashStr(`${this.Login}-${this.ConnectionName}${this.clientType}`);
    }
}
